import * as React from 'react';
import LinearProgress from '@material-ui/core/LinearProgress';

const removeIcon = require('../../resource/img/remove-default.svg');

interface BatchLinearProgressProps {
    fileName: string,
    uploaded: number,
    clickRemove: () => void
}

class BatchLinearProgress extends React.Component <BatchLinearProgressProps, {}> {
    public render() {
        return (
            <div className="cmInput cmFormInput batchLinearProgress">
                <div>
                    <label className="cmInputLabel">Upload File</label>
                    <div className="cmText batchLinearProgressFileName">{this.props.fileName}</div>
                </div>
                <div className="batchLinearProgressContainer">
                    <LinearProgress variant="determinate" value={this.props.uploaded}/>
                    <button onClick={(e) => this.props.clickRemove()}><img src={removeIcon}/></button>
                </div>
            </div>
        );
    }
}

export default BatchLinearProgress;



// WEBPACK FOOTER //
// ./src/Components/Batch/BatchLinearProgress.tsx